export default {
  brand: 'calcdeck',
  domain: 'calcdeck.ru',
  title: 'calcdeck.ru - бесплатные онлайн-калькуляторы',
  description:
    'Бесплатные локальные онлайн-калькуляторы для повседневных расчётов. Первый инструмент - процентный калькулятор без регистрации и отправки данных на сервер.',
  metrikaId: '110321981',
  ogImage: 'https://calcdeck.ru/og-image.png',
}
